const STORAGE_KEY_PREFIX = 'nexelem-tanstack-table-session:';

const getStorageKey = (tableName: string) => `${STORAGE_KEY_PREFIX}${tableName}`;

/**
 * Remembers the last encoded table state (`f` blob) per table for the browser tab session.
 * Used when the URL has no `f` (e.g. navigating back from a details page) so unsaved
 * filters/search/sort/columns survive remounts without requiring a named saved view.
 *
 * Precedence on load: URL `f` → session cache → default saved view → schema defaults.
 */
export const TableSessionState = {
  get(tableName: string): string | null {
    try {
      return sessionStorage.getItem(getStorageKey(tableName));
    } catch {
      return null;
    }
  },

  set(tableName: string, encoded: string | null): void {
    try {
      const key = getStorageKey(tableName);
      if (encoded === null) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, encoded);
      }
    } catch {
      // Ignore quota errors / private mode restrictions.
    }
  },
};
